import {TrackableEntity} from './data/ChangeTrackable';
import { PeriodClosingDetail } from './PeriodClosingDetail';

export class PeriodClosing extends TrackableEntity {
        endYearDate: string = '';

        // Not Mapped
        acctStartDate: string | null = null;
        lastCloseDate: string | null = null;
        canCreate: boolean = false;
        fiscalEndMonth: number = 0;
        currDay: number = 0;
        currMonth: number = 0;
        currYear: number = 0;
        isClose: boolean = false;

        closingList: PeriodClosingDetail[] = [];

    constructor(init?:Partial<PeriodClosing>) {
        super();
        this.key=undefined;
        Object.assign(this, init);
    }
}
